/**
 * Utilitário para normalização de números de telefone
 * Remove caracteres não numéricos e trata o 9º dígito brasileiro
 */

export const normalizePhone = (phone: string | null): string => {
  if (!phone) return '';
  let normalized = phone.replace(/\D/g, ''); // Remove tudo que não é dígito
  
  // Se o número tem 13 dígitos (55 + DDD + 9 + 8 dígitos) e o 5º dígito é '9'
  // Remove o 9º dígito para compatibilidade com formato antigo
  // Exemplo: 5582996168453 -> 558296168453
  if (normalized.length === 13 && normalized[4] === '9') {
    normalized = normalized.slice(0, 4) + normalized.slice(5);
  }
  
  return normalized;
};

/**
 * Compara dois números de telefone usando normalização
 */
export const comparePhones = (phone1: string | null, phone2: string | null): boolean => {
  const normalized1 = normalizePhone(phone1);
  const normalized2 = normalizePhone(phone2);
  return normalized1.length > 0 && normalized1 === normalized2;
};
